// extracted by mini-css-extract-plugin
module.exports = {"form":"Item-module--form--3bJK8","formList":"Item-module--formList--MfCff"};